import {
  EnvironmentProviders,
  inject,
  makeEnvironmentProviders,
  provideEnvironmentInitializer
} from '@angular/core';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { config } from '@fortawesome/fontawesome-svg-core';
import {
  faAnglesUp,
  faArrowDown,
  faArrowUp,
  faBan,
  faCalendar,
  faCaretDown,
  faCaretLeft,
  faCheck,
  faExternalLink,
  faGear,
  faMoneyBill,
  faPlus,
  faRefresh,
  faRemove,
  faSearch,
  faSignIn,
  faSignOut,
  faTriangleExclamation,
  faWarning,
  faWrench
} from '@fortawesome/free-solid-svg-icons';

// Icons are rendered by the <fa-icon> component: disable the Font Awesome
// features that scan and watch the whole document to replace <i> elements. This
// must run before Font Awesome starts watching the document (in a timeout once
// the DOM is ready).
config.autoReplaceSvg = false;
config.observeMutations = false;

/**
 * Registers the Font Awesome icons used in the application's templates.
 */
export function provideIcons(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideEnvironmentInitializer(() =>
      inject(FaIconLibrary).addIcons(
        faAnglesUp,
        faArrowDown,
        faArrowUp,
        faBan,
        faCalendar,
        faCaretDown,
        faCaretLeft,
        faCheck,
        faExternalLink,
        faGear,
        faMoneyBill,
        faPlus,
        faRefresh,
        faRemove,
        faSearch,
        faSignIn,
        faSignOut,
        faTriangleExclamation,
        faWarning,
        faWrench
      )
    )
  ]);
}
